import React, { Component } from 'react';

import { DropTarget, DragSource } from 'react-dnd'
import RemovableJumper from './removableJumper'
import EditableFunJumper from './editableFunJumper'
import loadsStore from '../../../stores/loads-store'
import AddJumpers from './addJumpers'
import swal from 'sweetalert';

const Types = {
    ITEM: 'JUMP'
};

const itemSource = {
    beginDrag(props) {
        //console.log('dragging');
        const item = props
        return item
    },
    endDrag(props, monitor, component) {
        //console.log('endrag')
        if (!monitor.didDrop()) {
            return;
        }
        //return props.handleJumperDrop(props)
        return props;
    }
}

function collect(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    }
}

class RenderJumperSource extends Component {

    handleCreateJumper(loadNum, jumpId, jumpPostBody) {

        //alert('in here');
        var that = this;
        Promise.all([loadsStore.addJumpers(loadNum, jumpId, jumpPostBody)])
            .then(function (result) {
                // console.log(result);
                if (result[0] === true) {
                    // console.log(result[0]);
                }
            })
    }

    handleJumperRemove(payload) {
        // loadsStore.removeJumper(loadNum, jumpId, jumperId);
        // console.log('Test');
        var that = this;
        var jumperArray = [];
        console.log(payload);
        jumperArray.push(payload.jumperId);
        var jumpPostBody = {
            //jumperIds: jumperArray
            "gearRentals": [],
            "jumperIds": [{
                jumperId: payload.jumper._id,
                price: payload.jumper.price,
                block: payload.jumper.block,
                blockId: payload.jumper.blockId,
                gearPrice: payload.jumper.gearPrice,
                gearType: payload.jumper.gearType,
                isLOing: payload.jumper.isLOing,
                tracked: payload.jumper.tracked
            }]
        }

        if (payload.jumper.studentgearRental) {
            jumpPostBody.studentgearRentals = [payload.jumper._id];

        }
        if (payload.jumper.sportgearRental) {
            jumpPostBody.sportgearRentals = [payload.jumper._id];
        }
        var jumpId = payload.jumpId;
        var loadNum = payload.loadNum;

        var sourceLoadNum = payload.oldLoadNum;
        var sourceJumpId = payload.oldJumpId;
        var jumperId = payload.jumper._id;
        if (sourceLoadNum === loadNum) {
            jumpPostBody.allowClosedOverride = true;
        }
        if (window.ENV?.disableRemoveAt8MinCall && payload.timeRemaining < 480 && sourceLoadNum !== loadNum) {
            swal({
                title: "Warning",
                text: "cannot remove less than 8 min call",
                icon: "warning",
                dangerMode: false,
            })
        }
        else {
            loadsStore.addJumpers(loadNum, jumpId, jumpPostBody)
                .then(r => {
                    if (r) {
                        loadsStore.removeJumper(sourceLoadNum, sourceJumpId, jumperId)
                    }
                })
            /*
            Promise.all([loadsStore.removeJumper(sourceLoadNum, sourceJumpId, jumperId)])
            .then(function (result) {
                //console.log(result);
                if (result[0] === true) {
                    // that.handleCreateJumper(payload.loadNum, payload.jumpId, jumpPostBody);
                    that.handleCreateJumper(loadNum, jumpId, jumpPostBody);
                    //that.handleJumperDrop(sourceLoadNum, sourceJumpId, jumperId);
                }
            })*/
        }

    }


    render() {
        const { funJump, loadNum, timeRemaining, jumpId, disabled, jumperOptions, isDragging, connectDragSource, load, src, loadsToShow, fontSize ,columnsPerGroup } = this.props;

        const opacity = isDragging ? 0 : 1;
        const jumperLength = funJump.jumpers.length;
        const jumpers = funJump.jumpers.map((jumper, index) => {

            var jumperClass = 'jumper-load';
            if (jumper.pending) {
                jumperClass = 'jumper-load-pending';
            }
            if (jumper.firstname === "HOLD" && jumper.lastname === "HOLD") {
                return (
                    <ul className="jumper-load" key={"fun" + jumper._id + index}>
                        <li key={jumper._id}>
                            <EditableFunJumper editMode={true} type={"funjump"} label={"V"} loadNum={loadNum} jumpId={jumpId} jumper={jumper}  handleCreateJumper={this.handleCreateJumper} handleJumperRemove={this.handleJumperRemove} />
                        </li>
                    </ul>
                )
            }
            else
                return (
                    <ul className={jumperClass} key={"fun" + jumper._id + index}>
                        <li>
                            <RemovableJumper loadNum={loadNum} timeRemaining={timeRemaining} jumpId={jumpId} jumper={jumper} handleCreateJumper={this.handleCreateJumper} funJump={funJump} handleJumperRemove={this.handleJumperRemove} />
                        </li>
                    </ul>
                );
        });

        var IsdisplayOnly = loadsStore.displayOnly ? 'none' : '';

        // return connectDragSource(
        return (
            // {}
            <div>
               {jumpers}
                {["HopNPop Student", "Solo Student"].indexOf(funJump.jumpType) >= 0 || IsdisplayOnly || this.props.isClosed || disabled ? null : <AddJumpers activeJumperIdsOnLoad={this.props.load.activeJumperIds} loadNum={loadNum} jumpId={jumpId} disabled={disabled} jumperOptions={jumperOptions} jumperLength={jumperLength} loadsToShow={loadsToShow} fontSize={fontSize} columnsPerGroup={columnsPerGroup} />}
                
            </div>
        )
    }
}

// export default DragSource(Types.ITEM, itemSource, collect)(RenderJumperSource)
export default RenderJumperSource;
